import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form";
import { getOwners, getLambingData } from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select.js";
import useListStyles from "../../components/styles/List.js";
import Spinner from "../../components/Spinner.js";
import { Typography, Box, Grid2 } from "@mui/material";
import Table from "../../components/Table.js";
import {
    damCodeHeaderNoClick,
    sireCodeHeaderNoClick,
    lambingDateHeader,
    prolificacyHeader,
    lactationNumberHeader,
    lambsHeader,
} from "../../components/TableHeaders.js";

const ReproductiveHistory = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [dateOptions, setDateOptions] = useState([]);
    const [fetchedLambings, setFetchedLambigs] = useState([]);

    const classes = useSelectStyles();
    const listClasses = useListStyles();
    const { error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners);
                setOwnersDropdownValues(owners.map((owner) => ({
                    value: `${owner?.code} - ${owner?.lastName} ${owner?.firstName}`,
                    text: `${owner?.code} - ${owner?.lastName} ${owner?.firstName}`
                })))
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        }
    )

    useEffect(() => {
        const yearOptions = Array.from(
            { length: new Date().getFullYear() - 2000 + 1 },
            (_, i) => `${new Date().getFullYear() - i - 1} - ${new Date().getFullYear() - i}`
        );

        setDateOptions(yearOptions.map((opt) => ({
            value: opt,
            text: opt
        })))

        fetchData();
    }, [])

    const ownerDateFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Επιλογή Εκτροφής",
            required: true,
        },
        {
            customType: "dropdown",
            id: "dateRange",
            items: dateOptions,
            placeholder: "Επιλογή Έτους",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Επιλογή",
        },
    ]

    const lambingsTableColumns = [
        damCodeHeaderNoClick,
        sireCodeHeaderNoClick,
        lambingDateHeader,
        lactationNumberHeader,
        prolificacyHeader,
        lambsHeader,
    ]
    const handleOwnerDateFormSubmit = async (values) => {
        setIsLoading(true);
        const ownerId = fetchedOwners.find((owner) => `${owner.code} - ${owner.lastName} ${owner.firstName}` === values.owner)?._id;
        const years = values.dateRange.split('-')
        const firstYear = years[0].trim();
        const secondYear = years[1].trim();
        const { success: scs, lambings, message } = await getLambingData(ownerId, firstYear, secondYear);
        if (scs) {
            setFetchedLambigs(lambings);
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <>
                    <Box className={classes.outerBox}>
                        <Box container flexDirection="column" className={classes.innerBox}>

                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Επιλογή εκτροφής και έτους"}
                            </Typography>
                            <Form
                                content={ownerDateFormContent}
                                onSubmit={handleOwnerDateFormSubmit}
                                toResetForm={false}
                            />
                        </Box>
                    </Box>
                </>
            )}
            {step === 2 && (
                <>
                    <Grid2 container className={listClasses.container} direction="column" sx={{ marginTop: "1rem", marginLeft: "3rem" }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                            <Typography variant="h5" className={listClasses.form_title}>
                                Τοκετοί
                            </Typography>
                        </Box>
                        <Table
                            data={fetchedLambings}
                            noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν τοκετοί!"}
                            columns={lambingsTableColumns}
                            defaultSorted={[{ id: "createdAt", desc: true }]}
                        />
                    </Grid2>
                </>
            )}
        </>
    )
}

export default memo(ReproductiveHistory);